module.exports = __webpack_public_path__ + "static/media/access_url_icn_dark.1aa56c2c.png";